module.exports = [
  { disabled: false, value: 'Lato, sans-serif', name: 'Lato' },
  { disabled: false, value: 'Montserrat, sans-serif', name: 'Montserrat' },
  { disabled: false, value: 'Open Sans, sans-serif', name: 'Open Sans' },
  { disabled: false, value: 'PT Sans, sans-serif', name: 'PT Sans' },
  { disabled: false, value: 'Roboto, sans-serif', name: 'Roboto' },
  {
    disabled: false,
    value: 'Source Sans Pro, sans-serif',
    name: 'Source Sans Pro',
  },
  { disabled: false, value: 'Ubuntu, sans-serif', name: 'Ubuntu' },
  { disabled: false, value: 'Poppins, sans-serif', name: 'Poppins' },
  { disabled: false, value: 'Karla, sans-serif', name: 'Karla' },
  { disabled: false, value: 'Nunito Sans, sans-serif', name: 'Nunito Sans' },
  { disabled: false, value: 'Work Sans, sans-serif', name: 'Work Sans' },
  { disabled: false, value: 'Abril Fatface, serif', name: 'Abril Fatface' },
  { disabled: false, value: 'Merriweather, serif', name: 'Merriweather' },
  { disabled: false, value: 'Roboto Slab, serif', name: 'Roboto Slab' },
  { disabled: false, value: 'PT Serif, serif', name: 'PT Serif' },
  { disabled: false, value: 'Inconsolata, monospace', name: 'Inconsolata' },
  {
    disabled: false,
    value: 'Source Code Pro, monospace',
    name: 'Source Code Pro',
  },
  {
    disabled: false,
    value: 'Space Grotesk, sans-serif',
    name: 'Space Grotesk',
  },
  {
    disabled: false,
    value: 'Patrick Hand, sans-serif',
    name: 'Patrick Hand',
  }
]
